import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '@tippyjs/react';
import styles from './Info.module.scss';
import 'tippy.js/dist/tippy.css';
import { useCallback } from 'react';

const Info = ({ children, className }) => {
  const handleOnCreate = useCallback((instance) => {
    instance.setProps({ animation: 'fade' });

    // Make it work on mobile ("touch" property seems useless for some reason)
    instance.reference.addEventListener('click', instance.show);
  }, []);

  return (
    <span className={`${styles.info} ${className ? className : ''}`}>
      <Tippy content={children} onCreate={handleOnCreate}>
        <div className={styles.infoSvg} />
      </Tippy>
    </span>
  );
};

Info.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  className: PropTypes.string,
};

export default Info;
